import { useState } from "react";
import { useSession } from "./SessionProvider";
import { useApi } from "../hooks/useApi";

const FileUpload = ({ type, allowMultiple }) => {
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const { setStatusTrigger } = useSession();
    const { apiCall } = useApi();

    const handleFileChange = (event) => {
        if (allowMultiple) {
            const files = event.target.files; // Get the selected files;
            setFile([...files]); // Store multiple files in state
        }
        else {
            setFile(event.target.files[0]);
        }
    };

    const handleUpload = async () => {
        if (!file) {
            setMessage("Please select a file first.");
            return;
        }

        setIsLoading(true);
        setMessage("Uploading...");
        const formData = new FormData();
        if (allowMultiple) {
            file.forEach((f, index) => {
                formData.append(`file[]`, f); // Append each file with an array syntax
            });

        }
        else {
            formData.append("file", file); // Append the single file to the FormData object
        }

        try {
            const response = await apiCall(
                'upload',
                {
                    method: 'POST',
                    params: { type },
                    body: formData,
                }
            );
            const data = await response.json();
            setMessage(data.message || data.error);
            if (data.success) {
                setStatusTrigger((prev) => prev + 1); // trigger status refresh

            }
        } catch (error) {
            setMessage("Error uploading file.");
        } finally {
            setIsLoading(false);

        }
    };

    return (
        <div>


            <div className="flex ">
                <input type="file" multiple={allowMultiple} onChange={handleFileChange} className="bg-gray-100 p-2 mr-2 cursor-pointer" />
                <button className="btn btn-primary" onClick={handleUpload} disabled={isLoading}>
                    {isLoading ? "Uploading..." : "Upload"}
                </button>
            </div>
            <div>

                {message && <p className="py-3" style={{ whiteSpace: 'pre-line' }}>{message}</p>}

            </div>
        </div>
    );
};

export default FileUpload;